import styled from "styled-components";
import { colors } from "styles";

export const Text = styled.article<{ color?: string }>`
  font-size: 10px;
  color: ${({ color }) => color || colors.blueGray};
  opacity: 0.8;
  margin: 16px 0;
`;
